import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-ink px-5 py-20 sm:py-28" data-id="element-16" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-17" data-mp="pj6bu2hqmgpy">
        <h2 className="text-center font-display text-[1.9rem] font-extrabold uppercase leading-tight text-white sm:text-[2.6rem]" data-id="element-18" data-mp="avd0wv3lk2dp">
          <span aria-hidden="true" data-id="element-19" data-mp="fsv9ulhm6hlp">🎁 </span>5 Exclusive Bonuses
        </h2>
        <p className="mt-2 text-center text-sm text-white/60" data-id="element-20" data-mp="1tvhp3uw7kks">
          Valued at{' '}
          <span className="font-bold text-white/45 line-through" data-id="element-21" data-mp="5vqhg3x6dpwg">$148 USD</span>{' '}
          — Included <span className="font-bold text-lime" data-id="element-22" data-mp="3o1v6kim4xyqq">FREE</span>
        </p>

        <ol className="mt-9 space-y-4" data-id="element-23" data-mp="3o3pum5spe6z1">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white/5 p-4 ring-1 ring-white/10" data-id="element-24" data-mp="3t0yafzqdpyx4" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand font-display text-base font-bold text-white" data-id="element-25" data-mp="1r9l9flrj8b6c">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-16 w-12 shrink-0 rounded object-cover" data-id="element-26" data-mp="3dg4wwqwi3shk" />
              <div data-id="element-27" data-mp="3r8ktb8uwcs9i">
                <h3 className="font-display text-lg font-bold uppercase leading-tight text-white" data-id="element-28" data-mp="3n5enu3flz543">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[11px] font-bold" data-id="element-29" data-mp="2zfu77r6xgjxz">
                  <span className="text-white/40 line-through" data-id="element-30" data-mp="2uh967pjupw8h">
                    was {bonus.was}
                  </span>{' '}
                  <span className="text-lime" data-id="element-31" data-mp="38htpemtohu2i">FREE</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}